import { ClearDiv, Col3Col9, DynamicTextEditor } from '@aon/aon-tws-common-ui';
import React from 'react';
import { useAppDispatch } from '../../../../appStore';
import Constants from '../../../../constants';
import ContentConstants from '../../../../contentConstants';
import { ITranslationEditItem } from '../../../../models';
import { updateSurveyIntroTranslation } from '../../../../store/SurveyIntroAdminSlice';
import { useSurveyDefaultCultureCode } from '../../../../utilities/hooks';
import { LabelAbove } from '../../../common';
import { TranslationEditorWrapper } from './TranslationEditorWrapper';

interface ISurveyIntroProps {
	translations: ITranslationEditItem[];
	supportedLanguages: string[];
	isSurveyClosed: boolean;
}

export const SurveyIntro = ({ translations, supportedLanguages, isSurveyClosed }: ISurveyIntroProps) => {
	const dispatch = useAppDispatch();
	const surveyDefaultCultureCode = useSurveyDefaultCultureCode();

	const defaultTranslation = translations.find((t) => t.cultureCode === surveyDefaultCultureCode);
	if (defaultTranslation === undefined) {
		return null;
	}

	return (
		<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_SURVEYINTRO} className={'tws-survey-intro-row'}>
			<LabelAbove type='input'>{ContentConstants.INPUTLABEL_SURVEY_INTRO}</LabelAbove>
			<DynamicTextEditor
				id='survey-intro-editor'
				inputType='textarea'
				enableHtmlEditor={true}
				placeholder={ContentConstants.SUBSECTIONHEADERS_SURVEYINTRO}
				onChange={(text: string) =>
					dispatch(updateSurveyIntroTranslation({ cultureCode: defaultTranslation.cultureCode, textValue: text }))
				}
				value={defaultTranslation.textValue}
				htmlEditorMode={'custom'}
				toolbarConfiguration={Constants.customHtmlEditorOptions}
				readOnly={isSurveyClosed}
			/>
			<ClearDiv clearHeight={'15px'} />
			<TranslationEditorWrapper
				enableHtmlEditor={true}
				property={'Intro'}
				inputType={'textarea'}
				disabled={isSurveyClosed}
				translations={translations}
				propertyDisplayName={ContentConstants.SUBSECTIONHEADERS_SURVEYINTRO}
				supportedLanguages={supportedLanguages}
				defaultTranslation={defaultTranslation}
				onChange={(payload) => dispatch(updateSurveyIntroTranslation(payload))}
			/>
		</Col3Col9>
	);
};
